import {styleKeys} from "./utils";

export function getNextBaseMap (styleName: string) {
    const keys = styleKeys;
    let index = styleKeys.indexOf(styleName);

    if (index === styleKeys.length - 1) {
        index = 0;
    }

    while (index < keys.length) {
        if (keys[index] !== styleName) {
            return keys[index];
        }
        index++;
    }
}